<template>
  <v-dialog v-model="dialog"
            persistent
            width="90%">
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-title>
          Replace "{{ slide.name }}" ({{ slide.id }})
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12"
                   sm="4"
                   md="4">
              <v-img :src="slide.image_url"
                     :title="slide.name"
                     :alt="slide.name"
                     class="border"
                     contain>
              </v-img>
            </v-col>

            <v-col cols="12"
                   sm="8"
                   md="8">
            </v-col>
          </v-row>

          <div class="text-h6 my-2">
            Select the replacement from the options below.
          </div>

          <v-simple-table fixed-header
                          dense
                          height="300px"
                          class="border">
            <thead>
            <tr>
              <th style="width: 80px;">
                Select
              </th>
              <th style="width: 240px;">
                Slide
              </th>
              <th style="width: 120px;">
                Status
              </th>
              <th style="width: 120px;">
                Distance
              </th>
              <th style="width: 120px;">
                ID
              </th>
              <th>
                Name
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="otherSlide in draftSlides"
                :key="otherSlide.id">
              <td>
                <v-checkbox v-model="form.replacement_id"
                            :value="otherSlide.id">
                </v-checkbox>
              </td>
              <td>
                <v-img :src="otherSlide.image_url"
                       width="240"
                       contain
                       class="my-4">
                </v-img>
              </td>
              <td>
                {{ otherSlide.status }}
              </td>
              <td>
                {{ otherSlide.distance }}
              </td>
              <td>
                {{ otherSlide.id }}
              </td>
              <td>
                {{ otherSlide.name }}
              </td>
            </tr>
            </tbody>
          </v-simple-table>

        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy || !form.replacement_id">
            Replace Slide
          </v-btn>
          <v-btn @click.prevent="closeDialog"
                 text>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import {find, orderBy} from 'lodash';
import slideDeckService from '../../../services/slideDeckService';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    slide: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      comparisons: [],
      form: new Form({
        replacement_id: null,
      }),
      slides: [],
    }
  },
  computed: {
    draftSlides() {
      return this.slides.filter(s => s.is_draft && s.id !== this.slide.id);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const comparisons = await slideDeckService.getComparisonsFor(this.slide.id);
      this.comparisons = orderBy(comparisons, ['distance', 'id'], ['asc', 'asc']);

      const slides = await slideDeckService.getSlidesForPresentation(this.slide.presentation_id);
      slides.forEach(s => {
        const minID = Math.min(this.slide.id, s.id);
        const maxID = Math.max(this.slide.id, s.id);
        const comparison = find(this.comparisons, c => (c.slide_id === minID && c.compared_slide_id === maxID));
        if (comparison) {
          s.distance = comparison.distance;
        } else {
          s.distance = Number.POSITIVE_INFINITY;
        }
      })
      this.slides = orderBy(slides, ['distance', 'position', 'id'], ['asc', 'asc', 'asc']);
    },
    async submit() {
      await slideDeckService.replaceSlide(this.slide.id, this.form.replacement_id);
      this.$emit('updated');
    },
    closeDialog() {
      this.$emit('closed');
    }
  }
}
</script>
